import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { i18n } from '../../../../translate/i18n';
import {Icon, TitleText} from './EventModalHeader.style';
import weekDayToText from '../../../../utils/weekDayToText';
import monthToText from '../../../../utils/monthToText';

const EventModalHeader = props => {

  const modalDate = useSelector(state => state.calendars.modalDate);
  const modalStage = useSelector(state => state.calendars.modalStage);
  const modalTitle = useSelector(state => state.calendars.modalTitle);

  const formatDateText = (date) => {
    const day = date.getDate();
    const weekDay = weekDayToText(moment(date).day());
    const month = monthToText(date.getMonth())
    const year = date.getFullYear();
    const today = new Date()

    return `${i18n.t('titleHeaderEvent.text')} ${day}, ${today.getMonth() === date.getMonth() ? weekDay : month} ${year}`
  }

  let showInCalendarAsScheduledInGreen = false;
  // modalData.payload.map(item => {
  //   if(item.showInCalendarAsScheduledInGreen === true) {
  //     return showInCalendarAsScheduledInGreen = true;
  //   } else {
  //     return showInCalendarAsScheduledInGreen = false;
  //   }
  // })

  let showInCalendarAsInProgressInGreen = false;
  // modalData.payload.map(item => {
  //   if(item.showInCalendarAsInProgressInGreen === true) {
  //     return showInCalendarAsInProgressInGreen = true;
  //   } else {
  //     return showInCalendarAsInProgressInGreen = false;
  //   }
  // })

  return (
    <div style={styles.headerContainer}>
      <Icon stage={modalStage} showInCalendarAsScheduledInGreen={showInCalendarAsScheduledInGreen} showInCalendarAsInProgressInGreen={showInCalendarAsInProgressInGreen} />
      <div style={styles.headerTextContainer}>
        <div style={styles.dateText}>{formatDateText(modalDate)}</div>
        <TitleText stage={modalStage} showInCalendarAsScheduledInGreen={showInCalendarAsScheduledInGreen} showInCalendarAsInProgressInGreen={showInCalendarAsInProgressInGreen}>{modalTitle}</TitleText>
      </div>
    </div>
  );
}

const styles = {
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginLeft: 5,
    marginBottom: 40
  },
  headerTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 10
  },
  dateText: {
    fontSize: '1.5rem'
  },
  titleText: {

  }
}


export default EventModalHeader;

